import React from 'react';
import { useSelector } from 'react-redux';
import { Card, Col, Row } from 'react-bootstrap';
import SelectedSensors from './SelectedSensors';
import SensorSelectorTable from './SensorSelectorTable';
import { selectSensorsData } from '../../../../redux/slices/alertFormSlice/alertFormSlice';

function SelectSensorsForm() {
  const { errorList } = useSelector(selectSensorsData);

  const sensorError = errorList.find((err) => err.field === 'sensorList');

  return (
    <Card className="alert-card">
      <Card.Body>
        <Row>
          <Col>
            <h6 className="alert-form-section-label">First, select your sensor(s)</h6>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col>
            <p className="mx-2">
              Select the + next to the first sensor you wish to alert on.
              You may select multiple sensor channels of the same reading type
              in order to create multiple alerts. Once you&apos;ve made a selection,
              the results in the table will automatically filter on your selected channel type.
            </p>
          </Col>
        </Row>
        {sensorError && (
          <div className="alert alert-danger mt-2" role="alert">
            {sensorError.message}
          </div>
        )}
        <SelectedSensors />
        <SensorSelectorTable />
      </Card.Body>
    </Card>
  );
}

export default SelectSensorsForm;
